/* global axios */
import ApiClient from './ApiClient';

class ContactPreferenceDefinitionsAPI extends ApiClient {
  constructor() {
    super('contact_preference_definitions', { accountScoped: true });
  }

  getActive() {
    return axios.get(this.url);
  }
}

export default new ContactPreferenceDefinitionsAPI();
